import { AppThunk } from '../../../../../store/types';
import { PhraseDetailsActions } from '../../../../../store/phrase-details/actions';
import { PhraseDetailsSelectors } from '../../../../../store/phrase-details/selectors';
import { PhraseDetailsTabsEditorPopupActions } from '../../../../../store/phrase-details-tabs-editor-popup/actions';
import { setMainViewMode } from '../../../../../store/general/actions';
import { EMainViewMode } from '../../../../../store/general/types';
import { EPhraseDetailsTabsEditorViewMode } from '../../../../../store/phrase-details-tabs-editor-popup/types';
import { EPhraseDetailsTabType } from '../../../../../store/models/types';
import { PhraseDetailsPromptLibEffects } from '../../../../../effects/phrase-details/phraseDetailsPromptLibEffects';
import { PhraseDetailsTabsEditorPopupSelectors } from '../../../../../store/phrase-details-tabs-editor-popup/selectors';
import { PhraseNoteEffects } from '../../../../../effects/phraseNoteEffects';
import { GptUtils } from '../../../../../effects/gptUtils';
import { historyPush } from '../../../../../../common/utils/historyHelper';
import { MainLayoutEffects } from '../../../../../effects/mainLayoutEffects';
import { PhraseListActions } from '../../../../../store/phrase-list/actions';
import { isLoggedUser } from '../../../../../store/general/selectors';
import { LoginPopupActions } from '../../../../../store/loginPopup/actions';
import { LimitStorage } from '../../../../../../common/utils/local-storage/local-storage-limit';
import { AIEffects } from '../../../../../effects/phrase/AIEffects';
import { getPhraseDetailsTabs } from '../../../../../store/models/selectors';

export class PhraseChatItemEvents {

	public static onLoad (
		useCache: boolean,
		type: EPhraseDetailsTabType,
		id?: number,
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const state = getState();
			if (!isLoggedUser(state)) {
				if (LimitStorage.getLimitAIReached()) {
					return dispatch(LoginPopupActions.set({
						show: true,
						text: 'Please login to use AI'
					}));	
				} else {
					LimitStorage.incLimitAI();
				}
			}

			const activeTab = PhraseDetailsSelectors.getActiveTab(state);
			if (activeTab?.type !== type || activeTab.relationId !== id) {
				const tabs = getPhraseDetailsTabs(state);
				const tab = tabs.find(t => t.relationId === id && t.type === type);
				if (tab) dispatch(PhraseDetailsActions.setActiveTab(tab));
			}

			dispatch(AIEffects.load(useCache, type, id));
		}
	}

	public static onClickSettings(
		type: EPhraseDetailsTabType,
		id?: number,
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {

			if (type === EPhraseDetailsTabType.LIB_PROMPT) {
				await PhraseDetailsPromptLibEffects.loadPromptLibs();
				const lib = PhraseDetailsTabsEditorPopupSelectors.getPromptLibById(getState(), id || 0);
				if (lib) {
					dispatch(setMainViewMode(EMainViewMode.PHRASE_DETAILS_TABS_EDITOR));
					dispatch(PhraseDetailsTabsEditorPopupActions.setViewMode(EPhraseDetailsTabsEditorViewMode.LIBS));
					dispatch(PhraseDetailsTabsEditorPopupActions.setOpenPromptLibId(lib.id));
					dispatch(PhraseDetailsTabsEditorPopupActions.setPromptTestResult(''));
				}
			} else {
				const tabs = getPhraseDetailsTabs(getState());
				if (tabs && tabs.length) {
					let t = tabs.find(tab => {
						return (type === EPhraseDetailsTabType.CUSTOM_PROMPT)
							? tab.relationId === id
							: tab.type === type;
					});
					id = t?.id || 0;
				}
				dispatch(setMainViewMode(EMainViewMode.PHRASE_DETAILS_TABS_EDITOR));
				dispatch(PhraseDetailsTabsEditorPopupActions.setViewMode(EPhraseDetailsTabsEditorViewMode.CREATE));
				dispatch(PhraseDetailsTabsEditorPopupActions.setEditTabId(id || 0));
			}
			historyPush({
				state: { page: 'settings' },
				title: 'Settings',
				onpopstate: () => dispatch(MainLayoutEffects.backToDashboard())
			});
		}
	}

	public static onCopyNote(
		type: EPhraseDetailsTabType,
		id?: number,
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const state = getState();

			if (!isLoggedUser(state)) {
				return dispatch(LoginPopupActions.set({
					show: true,
					text: 'Please login to save phrase'
				}));
			}
			// const group = getActiveUserGroup(getState());
			// if (group?.type === EUserGroupType.PREVIEW) {
			// 	SaveVideoConfirmManager.saveToMyStuff();
			// 	return;
			// }
			
			const item = PhraseDetailsSelectors.getPromptsChat(state)?.find(i => i.type === type && i.id === id);
			if (item) {
				dispatch(PhraseListActions.setNotePopup(true));
				let result = '';
				console.log('id', id)
				if (id) {
					let promptResult;
					if (type === EPhraseDetailsTabType.CUSTOM_PROMPT) {
						promptResult = PhraseDetailsSelectors.getCustomPrompt(state, id);
					} else if (type === EPhraseDetailsTabType.LIB_PROMPT) {
						promptResult = PhraseDetailsSelectors.getLibPrompt(state, id);
					}
					result = promptResult?.resultText;
				}
				if (!result) {
					if (type === EPhraseDetailsTabType.EXPLAIN) {
						result = PhraseDetailsSelectors.getExplainResultText(state) || '';
					} else if (type === EPhraseDetailsTabType.USAGE) {
						result = PhraseDetailsSelectors.getUsageResultText(state) || '';
					}
				}
				result = GptUtils.formatResult(result + '\n\n');

				setTimeout(() => {
					PhraseNoteEffects.runCopyToNoteText(result);
				}, 200);
			}
		}
	}

	public static onOpenNote(
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			// const state = getState();
			// const phraseId = PhraseDetailsSelectors.getPhraseId(state) || 0;
			// const phrase = PhraseListSelectors.findPhraseById(state, phraseId);
			// if (!phrase?.userGroupId) return;
			// const group = getUserGroupById(state, phrase.userGroupId);
			// if (!group) return;
			// const targetLang = getGroupTargetLanguage(state, group);
			// if (!targetLang) return;
			// const nativeLang = getGroupNativeLanguage(state, group);
			// PhraseDetailsEffects.showNoteFromSavedPhrase(targetLang, nativeLang, nativeLang, phrase.highlighted, phrase, true);
			// MainLayoutEffects.setPhrasesColumnTab(EPhrasesColumnTab.SAVED);

			dispatch(PhraseListActions.setNotePopup(true));
		}
	}

	public static onSelection(
		text: string,
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			text = text.replaceAll(/\n/gm, ' ').trim();
			dispatch(PhraseDetailsActions.setTranslateResult({
				edit: {
					enabled: !!text,
					text
				}
			}));
		}
	}

}